import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_bank_recon_hdr_RowClass,
  bl_fi_bank_recon_exts_RowClass,
  bl_fi_bank_recon_events_RowClass
} from '../../../dbschema/index';

export class BankReconContainerModel extends BaseContainerModel {
  bl_fi_bank_recon_hdr: bl_fi_bank_recon_hdr_RowClass = new bl_fi_bank_recon_hdr_RowClass();
  bl_fi_bank_recon_exts: bl_fi_bank_recon_exts_RowClass[] = [];
  bl_fi_bank_recon_events: bl_fi_bank_recon_events_RowClass[] = [];
}
